export default __webpack_public_path__ + "static/media/scritta.718605e6.png";